import * as React from 'react'
import type { Editor } from '@tiptap/react'
import { Select } from 'antd'
import { ChevronDownIcon } from '../../tiptap-icons/chevron-down-icon'


const FontSizeDropdown = ({ editor }: { editor: Editor | null }) => {
  if (!editor) return null

  const sizesOptions = ['8px', '10px','12px', '14px', '16px', '18px', '20px', '22px', '24px', '32px', '48px']
  const currentFontSize = editor?.getAttributes('textStyle').fontSize
  const fontSizeOptions = sizesOptions.map(size => ({
        label: size.replace('px', ''),
        value: size,
      }))
  const activeFont =
    sizesOptions.find((option) => {
      return option === currentFontSize
    }) || '14px'

  const handleChangeFontSize = (value: string) => {
      editor?.chain().focus().setFontSize(value).run()
  } 
  
  return (
    <Select
      variant='borderless'
      value={activeFont || undefined}
      onChange={handleChangeFontSize}
      options={fontSizeOptions}
      suffixIcon={<ChevronDownIcon width={'16px'} height={'16px'} />}
      className='sapp-toolbar-select'
      dropdownStyle={{ width: 60, textAlign: 'center' }}
      size='small'
    />
  )
}
export default FontSizeDropdown